import { z } from "zod";

import { InviteFormSchema } from "./invite-user";

export const UpdateUserFormSchema = InviteFormSchema.partial();
export const UpdateUserSchema = UpdateUserFormSchema.omit({ companyId: true });

export type UpdateUserForm = z.infer<typeof UpdateUserFormSchema>;
export type UpdateUser = z.infer<typeof UpdateUserSchema>;
